import { AxiosResponse } from "axios";
import { isEmpty } from "lodash";
import { dtoShareWithVet } from "../components/modals/AddVetModal";
import { CreateChukkerDto } from "../dto/createChukkerDto";
import { TPdfReport } from "../hooks/useExam";
import { Chukker, Chukkers } from "../shared/types/chukkers.type";
import { TExam, TKeyParamLayout } from "../shared/types/exam.type";
import { TQualifyChoice } from "../shared/types/qualifyChoices.type";
import { Ttraining } from "../shared/types/training.type";
import { TtrainingKeyParameter } from "../shared/types/trainingKeyParameter.type";
import { TuserAccountType } from "../shared/types/user.type";
import { TsavePreselects } from "../shared/utils/myTrainings";
import axiosInstance from "./base";

export class Exams {


    static getExams(trainer?: string | null, horse?: string, examsQueryParams?: string[], examPage?: number): Promise<AxiosResponse<Array<Ttraining>>> {

        return axiosInstance.get(`trainings?horseTrainer.trainer=${trainer}`
            .concat(horse ? `&horseTrainer.horse=${horse}` : "")
            // .concat('&' + Exams.encodeQueryParameter('additional-groups[]=training:insight'))
            .concat((examsQueryParams && !isEmpty(examsQueryParams)) ? '&' + examsQueryParams.map(Exams.encodeQueryParameter).join('&') : '')
            .concat(examPage ? `&page=${examPage}` : '')
        )
    }

    static getExam(exam: number, restricted?: boolean): Promise<AxiosResponse<TExam>> {
        let token = localStorage.getItem('share_token')
        return axiosInstance.get(`trainings/${exam}/show`.concat(restricted ? `?token=${token}` : ''))
    }
    static getChoices(id: number): Promise<AxiosResponse<any>> {
        return axiosInstance.get(`trainings/${id}/qualify_choices`)
    }
    static deleteTraining(id: number): Promise<AxiosResponse<any>> {
        return axiosInstance.patch(`trainings/${id}`, { hidden: true }, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }


    static editTraining(id: number, data: TQualifyChoice, postProcess: boolean = false): Promise<AxiosResponse<any>> {
        return axiosInstance.patch(`trainings/${id}/qualify?post-process-async=${postProcess}`, data, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }


    static changeInterval(interval: number, id?: number, restricted?: boolean) {
        let token = localStorage.getItem('share_token')

        return axiosInstance.get(`trainings/${id}/intervals/${interval}`.concat(restricted ? `?token=${token}` : ''))
    }

    static getTrainingsKeyParams(ids: string, date?: string, trainer?: string | null, options?: string, allKeyparams: boolean = true, exclueIncompleteTrainings = true,lang="en"): Promise<AxiosResponse<TtrainingKeyParameter>> {
        return axiosInstance.get(`training-key-parameters?
            add-unit=true&all_key_parameters=${allKeyparams}&exclude-live-incomplete-trainings=${exclueIncompleteTrainings}`
            .concat(ids ? `&${ids}` : '')
            .concat(trainer ? `&user=${trainer}` : '')
            .concat(date ? `&date=${date}` : '')
            .concat(options ? `&${options}` : '')
            .concat(`&lang=${lang}`)
        )

    }

    static getKeyParams(lang:string): Promise<AxiosResponse<TtrainingKeyParameter>> {
        return axiosInstance.get(`training-key-parameters?training=/api/training/96836&all_key_parameters=true&lang=${lang}`)
    }

    static getPreselects(type: TuserAccountType, nationality: string): Promise<AxiosResponse<TKeyParamLayout[]>> {
        return axiosInstance.get(`key_parameters_layouts?default_for_user_type=${type}&default_for_user_nationality=${nationality}`)
    }

    static deletePreselects(trainer?: string) {
        return axiosInstance.delete(`key_parameters_layouts/batch_delete?trainer=${trainer}`)
    }

    static savePreselects(data: TsavePreselects[]) {
        return axiosInstance.post('key_parameters_layouts/batch_upload', { key_parameters_layouts: data })
    }

    static getPostTraining(id?: number) {
        return axiosInstance.get(`trainings/${id}/post_process`)
    }

    static editTrainings(data: any): Promise<AxiosResponse<any>> {
        return axiosInstance.patch(`trainings/qualify_multiple`, data, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }

    static encodeQueryParameter(queryParameter: string): string {
        //if contains =, we split and encode, else, we juste encodeUriComponent

        if (queryParameter.includes("=")) {
            var splitted = queryParameter.split("=");
            return encodeURIComponent(splitted[0]) + "=" + encodeURIComponent(splitted[1]);
        } else {
            return encodeURIComponent(queryParameter);
        }

    }

    static downloadExamReport(id: number): Promise<AxiosResponse<TPdfReport>> {
        return axiosInstance.get(`trainings/${id}/pdf-report`)
    }

    static shareWithVet(id: number, data: dtoShareWithVet) {
        return axiosInstance.post(`trainings/${id}/share-with-vet`, data)
    }

    static downloadComparaisonPdf(examIds?: string, insightParams?: string): Promise<AxiosResponse<{ filename: string, url: string }>> {
        return axiosInstance.get(`trainings/comparison-pdf?`
            .concat(examIds ? `trainings=${examIds}` : '')
            .concat(examIds ? `&insight-parameters=${insightParams}` : ''))
    }

    static downloadAdvancedComparaisonPdf(examIds?: string, userId?: string): Promise<AxiosResponse<{ filename: string, url: string }>> {
        return axiosInstance.get(`/gallop-review-pdf?output-link=true&sorting=training.creation_date&`.concat(examIds || "").concat(`&user=${userId}`))
    }
    static exportExamPage(id: number): Promise<AxiosResponse<{ filename: string, url: string }>> {
        return axiosInstance.get(`trainings/${id}/export-page-pdf`)
    }

    static exportXlsx(ids: number[]): Promise<AxiosResponse<{ filename: string, file_url: string }>> {
        let paramQuery: string[] = []
        if (!isEmpty(ids)) {
            ids.map(id => paramQuery.push(`id${encodeURIComponent('[]')}=${id}`))
        }

        return axiosInstance.get(`trainings/export-moments?${paramQuery.join('&')}`)
    }

    static processTraining(id: number) {
        return axiosInstance.get(`trainings/${id}/post_process?async=true`)
    }


    static createChukker(data: (Chukker | CreateChukkerDto)[]): Promise<AxiosResponse<{ chukkers: Chukkers }>> {
        return axiosInstance.post(`chukkers/batch?post-process=true`, { chukkers: data })
    }
}